// bus.js文件内容
import Vue from 'vue'; // export default new Vue()

var Bus = new Vue();
export default Bus;